export class SceneStateMachinePlugin extends Phaser.Plugins.ScenePlugin {
  constructor(scene, pluginManager) {
    super(scene, pluginManager);

    this._stateCurrent = false;
    this._stateTransitions = [];
    this._stateOrder = [];
  }

  setStateOrder(value) {
    this._stateOrder = [...value];
  }

  nextState() {
    if (this._stateOrder.length === 0) return;
    if (!this._stateCurrent) this.setState(this._stateOrder[0]);
    else {
      const current = this._stateOrder.indexOf(this._stateCurrent);
      if (current < this._stateOrder.length - 1) {
        this.setState(this._stateOrder[current + 1]);
      }
    }
  }

  prevState() {
    if (this._stateOrder.length === 0) return;
    const current = this._stateOrder.indexOf(this._stateCurrent);
    if (current > 0) {
      this.setState(this._stateOrder[current - 1]);
    }
  }

  // =============================================================================================
  // ENABLE / DISABLE
  // =============================================================================================

  enable() {
    if (this._enabled) return;
    this._enabled = true;
    this._addSceneListeners();
  }

  disable(clearstate) {
    if (this._enabled) {
      this._enabled = false;
      this._removeSceneListeners();
    }
    if (clearstate) this.clearCurrentState();
  }

  // =============================================================================================
  // START / STOP STATES
  // =============================================================================================

  setState(state, properties) {
    // // end current state
    this.clearCurrentState();
    // start state
    this._stateCurrent = state;
    this._stateCurrent.startState(properties);
    this.enable();
  }

  addTransition(from, to, checkMethod, properties) {
    this._stateTransitions.push({ from, to, checkMethod, properties });
  }

  clearCurrentState() {
    if (this._stateCurrent) {
      this._stateCurrent.endState();
      this._stateCurrent = false;
      this._stateCurrentId = false;
    }
  }

  // =============================================================================================
  // SCENE EVENTS
  // =============================================================================================

  _addSceneListeners() {
    this.scene.events.on('update', this._handleSceneUpdate, this);
    this.scene.events.on('pause', this._handleScenePause, this);
    this.scene.events.on('resume', this._handleSceneResume, this);
    this.scene.events.on('shutdown', this._handleSceneShutdown, this);
  }

  _removeSceneListeners() {
    this.scene.events.off('update', this._handleSceneUpdate, this);
    this.scene.events.off('pause', this._handleScenePause, this);
    this.scene.events.off('resume', this._handleSceneResume, this);
    this.scene.events.off('shutdown', this._handleSceneShutdown, this);
  }

  _handleScenePause() {
    if (this._stateCurrent) this._stateCurrent.onScenePaused();
  }

  _handleSceneResume() {
    if (this._stateCurrent) this._stateCurrent.onSceneResumed();
  }

  _handleSceneUpdate(time, delta) {
    if (this._stateCurrent) {
      this._stateCurrent.onSceneUpdate(time, delta);
      const transition = this._checkStateTransitions(this._stateCurrent);
      if (transition) this.setState(transition.to, transition.properties);
    }
  }

  _handleSceneHud(btnid) {
    if (this.scene.scene.isPaused()) return;
    if (this._stateCurrent) this._stateCurrent.onSceneHud(btnid);
  }

  _handleSceneShutdown() {
    this.disable(true);
    this._removeSceneListeners();
    this._stateCurrent = null;
  }

  _checkStateTransitions(current) {
    const transition = this._stateTransitions.find(
      (transition) => transition.from == current && transition.checkMethod()
    );
    return transition;
  }
}

export class SceneState extends Phaser.Events.EventEmitter {
  constructor(scene) {
    super();
    this.scene = scene;
    this.game = scene.game;
  }

  startState(properties) {}
  onScenePaused() {}
  onSceneResumed() {}
  onSceneUpdate(time, delta) {}
  endState() {}
}
